import React, { useState, useEffect } from "react";
import { PostList } from "../../../components/Admin/Forum";
import { Navbar } from "../../../components/Admin/Forum/Navbar";
import { Button } from "semantic-ui-react";
import { BasicModal } from "../../../components/Shared";
import { PostForm } from "../../../components/Admin/Forum";
import { Subject } from "../../../api";
import { useAuth } from "../../../hooks";
import "./Forum.scss";

const subjectController = new Subject();

export function Forum() {
  const { accessToken } = useAuth();
  const [reload, setReload] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [subjectsOptions, setSubjectsOptions] = useState([]);
  const [filters, setFilters] = useState({
    status: "",
    subjectId: "",
    order: "",
  });

  const onReload = () => setReload((prevState) => !prevState);
  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);

  useEffect(() => {
    (async () => {
      try {
        setSubjectsOptions([]);
        const response = await subjectController.getSubjects(accessToken);
        const options = response.map((subject) => ({
          value: subject.id,
          text: subject.name,
        }));
        setSubjectsOptions(options);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [accessToken]);

  return (
    <>
      <div className="admin-forum-page">
        <div className="admin-forum-page__header">
          <Button
            className="admin-forum-page__add"
            primary
            onClick={onOpenCloseModal}
          >
            Crear publicación
          </Button>
        </div>

        <Navbar
          onReload={onReload}
          filters={filters}
          setFilters={setFilters}
          setCurrentPage={setCurrentPage}
          subjectsOptions={subjectsOptions}
        />

        <PostList
          filters={filters}
          reload={reload}
          onReload={onReload}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>

      <BasicModal
        size="large"
        show={showModal}
        close={onOpenCloseModal}
        title="Crear publicación"
      >
        <PostForm
          onReload={onReload}
          onClose={onOpenCloseModal}
          subjectsOptions={subjectsOptions}
        />
      </BasicModal>
    </>
  );
}
